export const isBetInputVisible = (
  isAutobrokerEnabled: boolean,
  isTopServiceUnavailable: boolean,
  isAuctionEnabled: boolean,
): boolean => {
  return !isAutobrokerEnabled && !isTopServiceUnavailable && isAuctionEnabled;
};
